module.exports = __webpack_public_path__ + "assets/img/SmartMedical.bdaf4ea5.png";